import useURLQueryParams from "./useURLQueryParams";

const useSourcePage = () => {
  const { source: sourcePage, vdr, tab, searchVersion } = useURLQueryParams();

  const isVPSourcePage = vdr === "vp";
  const isVPSoldSourcePage = isVPSourcePage && sourcePage === "Sold";
  const isVPExceptSoldPageOrTransportTab =
    isVPSourcePage && sourcePage !== "Sold" && tab !== "Transport";
  const isNewSearchPage = searchVersion === "new";

  return {
    sourcePage,
    isVPSourcePage,
    isVPSoldSourcePage,
    isVPExceptSoldPageOrTransportTab,
    isNewSearchPage,
  };
};

export default useSourcePage;
